import { useEffect } from 'react'
import { To, useNavigate, useParams } from 'react-router-dom'

/*
 * @Author: tager
 * @Date: 2022-06-17 17:12:27
 * @LastEditors: tager
 * @LastEditTime: 2022-06-17 17:12:56
 * @Description: file content
 */
export default function Redirect(props: { to: To }) {
  const navigate = useNavigate()
  const urlParams = useParams()
  useEffect(() => {
    const path = `${props.to}/${urlParams.id}${location.search}`.replace(
      /\/{2,}/,
      '/'
    )
    navigate(path)
  })
  return null
}
